import { render, staticRenderFns } from "./CargoCarriers.vue?vue&type=template&id=4acfc9ea&scoped=true&"
import script from "./CargoCarriers.vue?vue&type=script&lang=js&"
export * from "./CargoCarriers.vue?vue&type=script&lang=js&"
import style0 from "./CargoCarriers.vue?vue&type=style&index=0&id=4acfc9ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4acfc9ea",
  null
  
)

/* custom blocks */
import block0 from "./CargoCarriers.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports